import { renderGridTable } from "../ag-grid-render/render-grid-table";
import { agGridColumnDefs } from "../ag-grid-render/ag-grid-column-defs/ag-grid-column-defs";
import { getDatePattern } from "../date-formatters";
import dateRangePicker from "../date-range-picker";
import { formatToDatePayload, formatToDateTimePayload } from "../dates";
import { endOfDay, startOfDay } from "date-fns";

import toast from "../toast";

const emailManagementApi = {
  defaultParams: {
    startDate: new Date(),
    endDate: new Date()
  },
  branchRestricted: false,

  emailResponseTemplates: {
    NO_RESULTS: "There are no emails for your selected filter",
    ERROR_LOADING:
      "There has been an unexpected error when trying to load emails"
  },

  checkboxSelection(params) {
    return params.node.group ? true : false;
  },

  async gridTable() {
    const self = this;
    let responseTemplate = null;

    const columnDefs = agGridColumnDefs({
      pageInstance: this,
      tableRef: "emailManagementBoard"
    });

    const pageSize = 50;

    const options = {
      rowModelType: "serverSide",
      cacheBlockSize: pageSize,
      maxBlocksInCache: 10,
      blockLoadDebounceMillis: 100,
      multiSortKey: "ctrl",
      autoGroupColumnDef: {
        cellRenderer: "agGroupCellRenderer",
        cellRendererParams: {
          checkbox: true
        }
      },
      defaultColDef: {
        sortable: true,
        checkbox: self.checkboxSelection.bind(self)
      },
      serverSideDatasource: {
        getRows: (params) => {
          const request = params.request;
          const searchValue = (params.searchValue =
            params.parentNode.gridOptionsWrapper.gridOptions.searchValue);

          request.searchValue = searchValue ? searchValue : null;
          self.gridSearchValue = searchValue;

          request.valueCols = params.parentNode.columnApi
            .getAllColumns()
            .map((e) => {
              return {
                id: e.colDef.field,
                field: e.colDef.field,
                displayName: e.colDef.headerName
              };
            });

          const filterParams = this.defaultParams;
          const postData = {
            request: {
              ...request,
              ...filterParams
            },
            query: self.query
          };

          axios
            .post(`${server.serverTmsJobBooking}/ag-grid/mail`, postData)
            .then((response) => {
              if (response.status == 200) {
                const data = response.data.data;
                const rows = data.rows;
                const length = rows?.length || 0;

                const lastRowIndex = length
                  ? request.startRow + length
                  : request.startRow;

                if (length > 0) {
                  params.successCallback(
                    rows,
                    length >= pageSize ? -1 : lastRowIndex
                  );
                } else {
                  responseTemplate = this.emailResponseTemplates.NO_RESULTS;
                  params.successCallback(rows, lastRowIndex);
                  self.gridOptions.overlayNoRowsTemplate = responseTemplate;
                  self.gridOptions.api.showNoRowsOverlay();
                  toast.displayToast({
                    type: "error",
                    titleText: "Error",
                    bodyMessageText: responseTemplate
                  });
                }
              }
            })
            .catch(() => {
              responseTemplate = this.emailResponseTemplates.ERROR_LOADING;
              self.gridOptions.overlayNoRowsTemplate = responseTemplate;
              self.gridOptions.api.showNoRowsOverlay();
              toast.displayToast({
                type: "error",
                titleText: "Error",
                bodyMessageText: responseTemplate
              });
            });
        }
      },
      getChildCount: function (data) {
        return data ? data.count : "";
      },
      columnDefs,
      rowData: self.emailManagementData,
      overlayNoRowsTemplate: responseTemplate
    };
    renderGridTable({
      pageInstance: this,
      gridParams: {
        tableReference: "emailManagementBoard",
        holder: document.querySelector(".js-grid-table"),
        agGridOptions: options,
        searchTable: true
      },
      contextMenuOverride: self.getContextMenuItems.bind(this)
    });
    document
      .querySelector(".btn.btn-primary.js-expand-all-btn")
      .classList.add("d-none");
    document
      .querySelector(".btn.btn-primary.js-collapse-all-btn")
      .classList.add("d-none");
  },

  // this downloads directly, not to the queue
  getContextMenuItems() {
    const contextMenuItems = [];
    const exportParams = {
      fileName: `TMS - Email Management ${moment().format("YYYY-MM-DD")}`
    };

    contextMenuItems.push(
      "separator",
      {
        name: "Export to Excel",
        icon: '<i class="fal fa-file-export"></i>',
        action: () => {
          this.gridOptions.api.exportDataAsExcel(exportParams);
        }
      },
      "separator",
      {
        name: "Export to CSV",
        icon: '<i class="fal fa-file-export"></i>',
        action: () => {
          this.gridOptions.api.exportDataAsCsv(exportParams);
        }
      }
    );

    return contextMenuItems;
  },

  dateChangeHandler({ startDate, endDate }) {
    sessionStorage.setItem(
      "emailManagementStartDate",
      formatToDatePayload(startDate)
    );
    sessionStorage.setItem(
      "emailManagementEndDate",
      formatToDatePayload(endDate)
    );
    this.query = {
      ...this.query,
      startDate: formatToDateTimePayload(
        startOfDay(dateRangePicker.getDate("#js-date-field", "start").toDate())
      ),
      endDate: formatToDateTimePayload(
        endOfDay(dateRangePicker.getDate("#js-date-field", "end").toDate())
      ),
      branchRestricted: this.branchRestricted
    };
    const dateFieldValue = jQuery("#js-date-field").val();
    jQuery("#nav-date").val(dateFieldValue);
  },

  datesDropDown() {
    const datesDropDown = document.querySelector("#js-date-field");
    const startDateFromSession = sessionStorage.getItem(
      "emailManagementStartDate"
    );
    const startDate =
      startDateFromSession && startDateFromSession !== "null"
        ? new Date(startDateFromSession)
        : this.defaultParams.startDate;
    const endDateFromSession = sessionStorage.getItem("emailManagementEndDate");
    const endDate =
      endDateFromSession && endDateFromSession !== "null"
        ? new Date(endDateFromSession)
        : this.defaultParams.endDate;
    const options = {
      locale: {
        format: getDatePattern()
      },
      startDate,
      endDate,
      autoApply: true,
      showDropdowns: true,
      showCustomRangeLabel: true,
      linkedCalendars: false,
      alwaysShowCalendars: true
    };
    const callback = (start, end) => {
      requestAnimationFrame(() => {
        this.dateChangeHandler({
          startDate: start,
          endDate: end,
          reload: false
        });
      });
    };

    jQuery(datesDropDown).daterangepicker(options, callback);

    const drp = dateRangePicker.getInstance(datesDropDown);

    drp.setStartDate(startDate);
    drp.setEndDate(endDate);
    this.dateChangeHandler({
      startDate: startDate,
      endDate: endDate,
      reload: false
    });
  },

  filterHandler() {
    const resetFilterButton = document.querySelector(
      ".js-reset-global-filters"
    );
    const filterButton = document.querySelector(".js-apply-global-filters");

    filterButton.addEventListener("click", () => {
      this.gridTable();
    });

    resetFilterButton.addEventListener("click", () => {
      const { startDate, endDate } = this.defaultParams;
      dateRangePicker.setDate("#js-date-field", startDate, endDate);
      this.dateChangeHandler({ startDate, endDate, reload: false });
      requestAnimationFrame(() => {
        this.gridTable();
      });
    });
  },

  async init({ branchRestricted = false }) {
    this.branchRestricted = branchRestricted;
    this.datesDropDown();
    this.gridTable();
    this.filterHandler();
  }
};

export default emailManagementApi;
